import React from 'react';
import {
  CheckCircleOutlined, HourglassOutlined,
  WarningOutlined,
} from '@ant-design/icons';

export const getDisplayName = (parameterConfigurations, parameter) => {
  const parameterConfig = parameterConfigurations?.find((param) => param.standard_name === parameter.standard_name);
  const displayNameBase = parameterConfig?.display_name?.en || parameter?.standard_name || 'Unknown';

  if (parameterConfig?.standard_name === 'sea_water_temperature' && (parameter?.depth === 0 || !parameter?.depth)) {
    return `${displayNameBase} (Surface)`;
  }

  if (parameter?.depth && parameter.depth !== 0) {
    return `${displayNameBase} (${parameter.depth}M)`;
  }

  return displayNameBase;
};

export const getConnectionStatus = (latestTimestamp) => {
  const now = Date.now();
  const age = now - (latestTimestamp * 1000);

  // < 24 hours: online
  // 24-48 hours: delayed
  // > 48 hours: offline

  const status = age <= 24 * 60 * 60 * 1000
    ? 'online'
    : age <= 48 * 60 * 60 * 1000
      ? 'delayed'
      : 'offline';

  const statuses = [
    {
      status: 'online',
      icon: (
        <CheckCircleOutlined />
      ),
      label: 'Online',
      style: {
        background: '#1D3712',
        color: '#6ABE39',
        border: '1px solid #306317',
      },
    },
    {
      status: 'delayed',
      icon: (
        <HourglassOutlined />
      ),
      label: 'Delayed',
      style: {
        background: '#443111',
        color: '#F3CC62',
        border: '1px solid #594214',
      },
    },
    {
      status: 'offline',
      icon: (
        <WarningOutlined />
      ),
      label: 'Offline',
      style: {
        background: '#431418',
        color: '#F37370',
        border: '1px solid #58181C',
      },
    },
  ];

  return statuses.find((s) => s.status === status) || statuses[statuses.length - 1];
};
